import core, { App } from '@gin-betting/core';

const {
    utils: { checkOnRoute },
} = core;

const initBettingReadyIndicator = (initIndicator: (keys: string[]) => void) => {
    switch (true) {
        case checkOnRoute(App.Routes.TOURNAMENT): {
            initIndicator(['hasTitle', 'hasData']);

            break;
        }

        case checkOnRoute(App.Routes.MATCH): {
            initIndicator(['hasTitle', 'hasData']);

            break;
        }

        case checkOnRoute(App.Routes.OUTRIGHT): {
            initIndicator(['hasTitle', 'hasData']);

            break;
        }

        default: {
            break;
        }
    }
};

export default initBettingReadyIndicator;
